//==========================================================================
// entry.js - Japanese Member Registration Form Validation
//==========================================================================

let hasRetried = false;

function setReactInputValue(element, value) {
  const lastValue = element.value;
  element.value = value;
  const tracker = element._valueTracker;
  if (tracker) tracker.setValue(lastValue);

  element.dispatchEvent(new Event('input', { bubbles: true }));
  element.dispatchEvent(new Event('change', { bubbles: true }));
}

function fillHeliumField(sourceInput, targetInput) {
  if (!sourceInput || !targetInput) return;

  if (targetInput.tagName === 'SELECT') {
    const option = Array.from(targetInput.options).find(
      opt => opt.value === sourceInput.value || opt.text === sourceInput.value
    );
    if (option) {
      targetInput.value = option.value;
      targetInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  } else {
    setReactInputValue(targetInput, sourceInput.value);
  }
}

function syncHeliumErrors(wrapper, heliumForm) {
  const heliumErrors = heliumForm.querySelector('.cf-step-invalid');

  if (!heliumErrors) {
    wrapper.innerHTML = '';
    return 'no-error';
  }

  const text = heliumErrors.textContent;

  if (text.includes('そのメールアドレスは既に使用されています')) {
    const errorHTML = heliumErrors.innerHTML.replace(
      /そのメールアドレスは既に使用されています。/g,
      '登録済み（または退会処理完了前）のユーザーです。'
    );
    wrapper.innerHTML = '';
    const errorBox = document.createElement('div');
    errorBox.className = 'my-form-errors c-form__error';
    errorBox.innerHTML = errorHTML;
    wrapper.appendChild(errorBox);
    return 'specific';
  }

  wrapper.innerHTML = '';
  return 'other';
}

function triggerReactClick(element) {
  const event = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
  element.dispatchEvent(event);
}

function syncCustomFieldFormData(form, heliumForm) {
  const customMapping = {
    'h_birth_date': 'h_birth_date',
    'h_gender': 'h_gender',
    'h_job': 'h_job',
    'h_accepts_dm': 'h_accepts_dm',
    'h_accepts_email_marketing': 'h_accepts_email_marketing'
  };

  Object.keys(customMapping).forEach((sourceField) => {
    const targetField = customMapping[sourceField];

    // h_job dropdown
    if (sourceField === 'h_job') {
      const h_jobDropdown = form.querySelector(`.js-dropdown[data-name="h_job"]`);
      const selectedValue = $(h_jobDropdown).find('.c-form__select-toggle').data('value') || '';
      const targetSelect = heliumForm.querySelector(`select[name="${targetField}"]`);
      if (targetSelect) setReactInputValue(targetSelect, selectedValue);
      return;
    }

    // BIRTH DATE
    if (sourceField === 'h_birth_date') {
      const year = $(form).find('.js-dropdown[data-name="birth-year"] .c-form__select-toggle').data('value') || '';
      const month = $(form).find('.js-dropdown[data-name="birth-month"] .c-form__select-toggle').data('value') || '';
      const day = $(form).find('.js-dropdown[data-name="birth-day"] .c-form__select-toggle').data('value') || '';

      if (year && month && day) {
        const selects = heliumForm.querySelectorAll('.cf-date-field--inline-inputs select');
        if (selects.length === 3) {
          setReactInputValue(selects[0], parseInt(month, 10));
          setReactInputValue(selects[1], parseInt(day, 10));
          setReactInputValue(selects[2], parseInt(year, 10));
        }
      } else {
        const selects = heliumForm.querySelectorAll('.cf-date-field--inline-inputs select');
        if (selects.length === 3) {
          setReactInputValue(selects[0], '');
          setReactInputValue(selects[1], '');
          setReactInputValue(selects[2], '');
        }
      }
      return;
    }

    // RADIO + TEXT/SELECT handling
    const sourceInputs = form.querySelectorAll(`[name="${sourceField}"]`);
    const targetInputs = heliumForm.querySelectorAll(`[name="${targetField}"]`);
    if (!sourceInputs.length || !targetInputs.length) return;

    const sourceType = sourceInputs[0].type;
    if (sourceType === 'radio') {
      const checkedSource = [...sourceInputs].find(input => input.checked);
      if (checkedSource) {
        const targetToCheck = [...targetInputs].find(input => input.value === checkedSource.value);
        if (targetToCheck) {
          triggerReactClick(targetToCheck);
        }
      }
      return;
    }

    // TEXT / SELECT / CHECKBOX
    const sourceInput = sourceInputs[0];
    const targetInput = targetInputs[0];
    if (targetInput && sourceInput) {
      setReactInputValue(targetInput, sourceInput.value);
    }
  });
}

function initValidateForm() {
  // jQuery validation rules and messages
  function initSubmitHandler(form) {
    // Show loading state
    const submitButton = $(form).find('button[type="submit"]');
    const originalText = submitButton.find('.c-btn__detail-txt').text();
    submitButton.find('.c-btn__detail-txt').text('送信中...');
    submitButton.prop('disabled', true);


    const mapping = {
      first_name: 'first_name',
      last_name: 'last_name',
      h_first_name_kana: 'h_first_name_kana',
      h_last_name_kana: 'h_last_name_kana',
      email: 'email',
      password: 'password',
      'default_address.company': 'default_address.company',
      'default_address.phone': 'default_address.phone',
      'default_address.address1': 'default_address.address1',
      'default_address.address2': 'default_address.address2',
      'default_address.city': 'default_address.city',
      'default_address.province': 'default_address.province',
      'default_address.zip': 'default_address.zip',
    };

    const heliumForm = document.getElementById('create_customer');
    const errorWrapper = document.getElementById('accout_form_wrapper');

    Object.keys(mapping).forEach((sourceField) => {
      const targetField = mapping[sourceField];
      const sourceInput = form.querySelector(`[name="${sourceField}"]`);
      const targetInput = heliumForm.querySelector(`[name="${targetField}"]`);
      fillHeliumField(sourceInput, targetInput);
    });

    // Custom data
    syncCustomFieldFormData(form, heliumForm);

    const getSubmitButton = (form) =>
      form.querySelector('button[type="submit"], .cf-submit-form, input[type="submit"]');

    let heliumSubmitBtn = getSubmitButton(heliumForm);

    if (!heliumSubmitBtn) {
      heliumSubmitBtn = document.createElement('button');
      heliumSubmitBtn.type = 'submit';
      heliumSubmitBtn.style.display = 'none';
      heliumForm.appendChild(heliumSubmitBtn);
    }

    setTimeout(() => {
      heliumSubmitBtn.click();
    }, 0);

    setTimeout(function () {
      submitButton.find('.c-btn__detail-txt').text(originalText);
      submitButton.prop('disabled', false);
    }, 10000);

    // watch for error node insertion
    const observer = new MutationObserver(() => {
      const result = syncHeliumErrors(errorWrapper, heliumForm);

      if (result === 'specific') {
        submitButton.disabled = false;
        submitButton.find('.c-btn__detail-txt').text(originalText);

        window.scrollTo({ top: errorWrapper.offsetTop - 20, behavior: 'smooth' });
      } else if (result === 'other' && !hasRetried) {
        hasRetried = true;
        submitButton.disabled = false;
        submitButton.find('.c-btn__detail-txt').text(originalText);
        setTimeout(() => {
          initSubmitHandler(form); // retry once
        }, 100);
      }
    });

    observer.observe(heliumForm, { childList: true, subtree: true });
  }

  $("#accout_form").validate({
    rules: {
      last_name: {
        required: true,
        maxlength: 50
      },
      first_name: {
        required: true,
        maxlength: 50
      },
      h_last_name_kana: {
        required: true,
        katakanaOnly: true,
        maxlength: 50
      },
      h_first_name_kana: {
        required: true,
        katakanaOnly: true,
        maxlength: 50
      },
      "default_address.company": {
        maxlength: 100
      },
      "default_address.zip": {
        required: true,
        postalCodeJP: true
      },
      "default_address.address1_show": {
        required: true,
        maxlength: 200
      },
      "default_address.address2": {
        required: true,
        maxlength: 200
      },
      "default_address.phone": {
        required: true,
        phoneJP: true
      },
      email: {
        required: true,
        email: true,
        maxlength: 100
      },
      email_confirm: {
        required: true,
        email: true,
        equalTo: "#email"
      },
      password: {
        required: true,
        passwordStrength: true,
        minlength: 8,
        maxlength: 32
      },
      password_confirm: {
        required: true,
        equalTo: "#password"
      },
      "h_accepts_dm": {
        required: true
      },
      "h_accepts_email_marketing": {
        required: true
      }
    },
    messages: {
      last_name: {
        required: "姓を入力してください。",
        maxlength: "姓は50文字以内で入力してください。"
      },
      first_name: {
        required: "名を入力してください。",
        maxlength: "名は50文字以内で入力してください。"
      },
      h_last_name_kana: {
        required: "姓（カナ）を入力してください。",
        katakanaOnly: "姓（カナ）は全角カタカナで入力してください。",
        maxlength: "姓（カナ）は50文字以内で入力してください。"
      },
      h_first_name_kana: {
        required: "名（カナ）を入力してください。",
        katakanaOnly: "名（カナ）は全角カタカナで入力してください。",
        maxlength: "名（カナ）は50文字以内で入力してください。"
      },
      "default_address.company": {
        maxlength: "会社名は100文字以内で入力してください。"
      },
      "default_address.zip": {
        required: "郵便番号を入力してください。",
        postalCodeJP: "郵便番号は7桁の数字（ハイフンなし）で入力してください。"
      },
      "default_address.address1_show": {
        required: "市区町村名を入力してください。",
        maxlength: "住所は200文字以内で入力してください。"
      },
      "default_address.address2": {
        required: "番地・ビル名を入力してください。",
        maxlength: "住所は200文字以内で入力してください。"
      },
      "default_address.phone": {
        required: "電話番号を入力してください。",
        phoneJP: "電話番号は正しい形式で入力してください。"
      },
      email: {
        required: "メールアドレスを入力してください。",
        email: "正しいメールアドレスの形式で入力してください。",
        maxlength: "メールアドレスは100文字以内で入力してください。"
      },
      email_confirm: {
        required: "確認用メールアドレスを入力してください。",
        email: "正しいメールアドレスの形式で入力してください。",
        equalTo: "メールアドレスが一致しません。"
      },
      password: {
        required: "パスワードを入力してください。",
        passwordStrength: "8〜32文字の半角英数・記号で入力してください。",
        minlength: "パスワードは8文字以上で入力してください。",
        maxlength: "パスワードは32文字以内で入力してください。"
      },
      password_confirm: {
        required: "確認用パスワードを入力してください。",
        equalTo: "パスワードが一致しません。"
      },
      h_accepts_dm: {
        required: "DMの送付をお選びください。",
      },
      h_accepts_email_marketing: {
        required: "メールマガジン送付をお選びください。",
      }
    },
    errorPlacement: function (error, element) {
      // Place error message after the input field
      error.addClass('c-form__error');
      error.insertAfter(element);
    },
    highlight: function (element, errorClass, validClass) {
      $(element).addClass('c-form__input--error');
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).removeClass('c-form__input--error');
    },
    submitHandler: function (form) {

      initSubmitHandler(form);
      return false;
    }
  });
}

// Custom validation methods
$.validator.addMethod("katakanaOnly", function (value, element) {
  if (this.optional(element)) {
    return true;
  }
  return /^[ァ-ヶー\s]+$/.test(value);
}, "全角カタカナで入力してください。");

$.validator.addMethod("postalCodeJP", function (value, element) {
  if (this.optional(element)) {
    return true;
  }
  return /^\d{7}$/.test(value);
}, "郵便番号は7桁の数字で入力してください。");

$.validator.addMethod("phoneJP", function (value, element) {
  if (this.optional(element)) {
    return true;
  }
  // Japanese phone number patterns (landline and mobile)
  return /^(0[1-9]\d{8,9}|0[5789]0\d{8})$/.test(value.replace(/-/g, ''));
}, "正しい電話番号を入力してください。");

$.validator.addMethod("passwordStrength", function (value, element) {
  if (this.optional(element)) {
    return true;
  }
  // Must contain at least one letter, one number, and be 8-32 characters
  return /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,32}$/.test(value);
}, "パスワードは半角英数記号を含む8〜32文字で入力してください。");

// Auto-fill address from postal code
function initPostalCodeAutoFill() {
  $('.c-form__btn-zipcode').on('click', function (e) {
    e.preventDefault();
    const postalCode = $('#postal_code').val();

    if (!postalCode || !/^\d{7}$/.test(postalCode)) {
      alert('正しい郵便番号を入力してください。（7桁の数字）');
      return;
    }

    // The yubinbango library should automatically fill the address fields
    // when postal code is entered and this button is clicked

    // Manual trigger for yubinbango
    if (typeof YubinBango !== 'undefined') {
      YubinBango.p = postalCode;
      YubinBango.callback = function () {
        // Address fields should now be populated
        $('#address1').trigger('blur'); // Trigger validation
      };
    } else {
      console.warn('YubinBango library not loaded');
    }
  });
}

// Real-time validation feedback
function initRealtimeValidation() {
  // Postal code formatting
  $('#postal_code').on('input', function () {
    let v = $(this).val().replace(/\D/g, '');
    if (v.length > 7) v = v.substring(0, 7);
    $(this).val(v);

    var validator = $("#accout_form").data('validator');
    if (validator) {
      validator.element(this);
    }
  });

  // Phone number formatting
  $('#phone').on('input', function () {
    let value = $(this).val().replace(/[^\d-]/g, ''); // Keep only digits and hyphens
    $(this).val(value);
  });

  // Katakana validation for name fields
  $('#h_last_name_kana, #h_first_name_kana').on('input', function () {
    const value = $(this).val();
    if (value && !/^[ァ-ヶー\s]*$/.test(value)) {
      $(this).addClass('c-form__input--warning');
    } else {
      $(this).removeClass('c-form__input--warning');
    }
  });

  // Password strength indicator
  $('#password').on('input', function () {
    const password = $(this).val();
    let strength = 0;

    if (password.length >= 8) strength++;
    if (/[a-z]/.test(password)) strength++;
    if (/[A-Z]/.test(password)) strength++;
    if (/\d/.test(password)) strength++;
    if (/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) strength++;

    // Remove existing strength classes
    $(this).removeClass('c-form__input--weak c-form__input--medium c-form__input--strong');

    if (password.length > 0) {
      if (strength <= 2) {
        $(this).addClass('c-form__input--weak');
      } else if (strength <= 3) {
        $(this).addClass('c-form__input--medium');
      } else {
        $(this).addClass('c-form__input--strong');
      }
    }
  });
}

(function disableYubinbangoAuto() {
  var pc = document.getElementById('postal_code');
  if (pc) {
    pc.classList.remove('p-postal-code');
    pc.classList.add('js-postal-code');
  }
})();

$('#postal_code').on('input', function () {
  var v = $(this).val().replace(/\D/g, '');
  if (v.length > 7) v = v.substring(0, 7);
  $(this).val(v);
});


// Password toggle visibility
function initPasswordToggle() {
  document.querySelectorAll('.c-form__password-toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var targetId = this.getAttribute('data-target');
      var input = document.getElementById(targetId);
      var iconEye = this.querySelector('.icon-eye');
      var iconEyeOff = this.querySelector('.icon-eye-off');

      if (input.type === 'password') {
        input.type = 'text';
        iconEye.style.display = 'none';
        iconEyeOff.style.display = 'block';
        this.setAttribute('aria-label', 'パスワードを非表示');
      } else {
        input.type = 'password';
        iconEye.style.display = 'block';
        iconEyeOff.style.display = 'none';
        this.setAttribute('aria-label', 'パスワードを表示');
      }
    });
  });
}

//------------------------------
$(function () {
  initValidateForm();

  initRealtimeValidation();

  initPasswordToggle();
});